import React from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { pxTransform } from "../_util/px-transform";
import { getRowKeyFromRecordKey } from "./util/get-row-key-from-record-key";
import { getValueByPathKey } from "./util/get-value-by-path-key";
import { injectValue } from "../_util/inject-value";
import { useConfig } from "../_util/use-config";
export function Table(_a) {
    var _b, _c;
    var _d = _a.layout, layout = _d === void 0 ? "auto" : _d, columns = _a.columns, records = _a.records, recordKey = _a.recordKey, width = _a.width, className = _a.className, style = _a.style;
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, { className: classNames(classPrefix + "-table__container", className, (_b = {},
            _b[classPrefix + "-table__container--bordered"] = false,
            _b)), style: style },
        React.createElement(View, { className: classNames(classPrefix + "-table", (_c = {},
                _c[classPrefix + "-table--fixed"] = layout === "fixed",
                _c)), style: {
                width: typeof width === "number" ? pxTransform(width, 750) : width,
            } },
            React.createElement(View, { className: classPrefix + "-table__colgroup" }, columns.map(function (_a) {
                var key = _a.key, _b = _a.width, width = _b === void 0 ? "auto" : _b;
                return (React.createElement(View, { className: classPrefix + "-table__col", key: key, style: {
                        width: typeof width === "number" ? pxTransform(width, 750) : width,
                    } }));
            })),
            React.createElement(View, { className: classPrefix + "-table__header" },
                React.createElement(View, { className: classPrefix + "-table__tr" }, columns.map(function (column) { return (React.createElement(View, { className: classNames(classPrefix + "-table__th", classPrefix + "-text--" + (column.align || "left")), key: column.key }, injectValue(column.header)(column))); }))),
            React.createElement(View, { className: classPrefix + "-table__body" }, records.map(function (record, recordIndex) {
                var rowKey = getRowKeyFromRecordKey(recordKey)(record, recordIndex);
                return (React.createElement(View, { className: classPrefix + "-table__tr", key: rowKey }, columns.map(function (column, columnIndex) { return (React.createElement(View, { className: classNames(classPrefix + "-table__td", classPrefix + "-text--" + (column.align || "left")), key: column.key }, typeof column.render !== "function"
                    ? getValueByPathKey(record, column.key)
                    : column.render(record, {
                        rowKey: rowKey,
                        recordIndex: recordIndex,
                        column: column,
                        columnIndex: columnIndex,
                    }))); })));
            })))));
}
//# sourceMappingURL=Table.js.map